import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Branding.css'
import brandingHero from "../../../assets/images/Brand Identity Design.png";
import brandElements from "../../../assets/images/Brand Identity Design.png";

const BrandingDesign = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Branding Design – BuddyTech Solutions </title>
        <meta name="description" content="Build your brand identity through cohesive color palettes, typography and visual style." />
        <meta name="keywords" content="branding, visual identity" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Branding Design – BuddyTech Solutions" />
        <meta property="og:description" content="Build your brand identity through cohesive color palettes, typography and visual style." />
        <meta property="og:keywords" content="branding, visual identity" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/graphics/branding" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Branding Design – BuddyTech Solutions" />
        <meta name="twitter:description" content="Build your brand identity through cohesive color palettes, typography and visual style." />
        <meta name="twitter:keywords" content="branding, visual identity" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="branding-container">
        <header className="branding-hero">
          <div className="branding-hero-content">
            <h1>Brand Identity Design</h1>
            <p>
              We build timeless brand identities that reflect your mission, connect with your audience, and establish a powerful visual voice.
            </p>
          </div>
          <img src={brandingHero} alt="Branding Hero" className="branding-hero-img" />
        </header>

        <section className="branding-section">
          <div className="branding-text">
            <h2>What We Deliver</h2>
            <p>
              A brand is more than just a logo. We help you shape how the world sees you through strategic visuals and design systems tailored for recognition, consistency, and trust.
            </p>
            <ul>
              <li>Logo Design & Guidelines</li>
              <li>Color Palette & Typography</li>
              <li>Business Cards & Stationery</li>
              <li>Brand Strategy & Messaging</li>
              <li>Social Media Visual Identity</li>
            </ul>
          </div>
          <img src={brandElements} alt="Brand Identity Elements" className="branding-img" />
        </section>

        <section className="branding-tools">
          <h2>Tools & Platforms</h2>
          <div className="tools-grid">
            <span>Adobe Illustrator</span>
            <span>Photoshop</span>
            <span>Figma</span>
            <span>Canva</span>
            <span>CorelDRAW</span>
            <span>Sketch</span>
            <span>Affinity Designer</span>
            <span>Adobe Express</span>
          </div>
        </section>

        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:developerjayaprakash91@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919842084312" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919842084312">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default BrandingDesign;